/**
 * <s-sticky-atc> — shows the sticky add-to-cart bar while the main product form's Add to cart button is
 * off-screen (and the shopper has scrolled past it), hiding it again when the footer comes into view.
 * Keeps the bar's price in step with the main form after variant changes.
 */
class SStickyAtc extends HTMLElement {
  #ac;
  #observer;
  #mainVisible = true;
  #footerVisible = false;
  #pastMain = false;

  connectedCallback() {
    this.#ac = new AbortController();
    const formId = this.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const mainButton = form?.querySelector('button[name="add"]') || form;
    const footer = document.querySelector('footer, [data-site-footer]');
    if (!mainButton) return;

    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === footer) {
          this.#footerVisible = entry.isIntersecting;
        } else {
          this.#mainVisible = entry.isIntersecting;
          this.#pastMain = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        }
      }
      this.#render();
    });
    this.#observer.observe(mainButton);
    if (footer) this.#observer.observe(footer);

    // Mirror the main price block after variant swaps.
    form?.closest('s-product-form')?.parentElement?.addEventListener('change', () => {
      window.setTimeout(() => this.#syncPrice(), 600);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#ac?.abort();
  }

  #render() {
    const show = !this.#mainVisible && this.#pastMain && !this.#footerVisible;
    this.toggleAttribute('data-visible', show);
    this.toggleAttribute('inert', !show);
  }

  #syncPrice() {
    const source = document.querySelector('[data-product-price] bdi[data-dert-money]');
    const target = this.querySelector('[data-sticky-price]');
    if (source && target) target.innerHTML = source.outerHTML;
  }
}

if (!customElements.get('s-sticky-atc')) {
  customElements.define('s-sticky-atc', SStickyAtc);
}
